module.exports = __webpack_public_path__ + "img/logo.6190878d.png";